import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const Tasks = () => {
  return (
    <MotionBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      p={5}
    >
      <Text fontSize="2xl" fontWeight="bold">
        Tasks
      </Text>
      <Text>This is the tasks page. Implement your tasks here.</Text>
    </MotionBox>
  );
};

export default Tasks;
